import React, { useState, useEffect } from 'react'
import { createPortal } from "react-dom";
import Modal from 'react-bootstrap/Modal'
import ErrorAlert from '../Alerts/ErrorAlert';
import LoadingAlert from '../Alerts/LoadingAlert';
import ModalParthners from './ModalParthners';
import { UsersFetchAPI } from '../../api/Users';
import Swal from 'sweetalert2';
import Keyboard from '../utils/Keyboard';

import './css/lgn.css';


function ModalLoginUserByCode({ showLoginByCode, setShowLoginByCode, businessLogo, parthners, selectRestaurant, setResetData, calculateInvoiceTotals, shoppingCart, shoppingCartCombos, setShoppingCart, setShoppingCartCombos, setShowModalWarehouses, warehouses }) {

    const [passwordUser, setPasswordUser] = useState('');
    const [showVirtualKeyboard, setShowVirtualKeyboard] = useState(true);
    const [stepLogin, setStepLogin] = useState('code');
    const [keyboardMode, setKeyboardMode] = useState('letters_upper');
    const [authMode, setAuthMode] = useState('code_only');
    const [codeUser, setCodeUser] = useState('')
    const [showPassword, setShowPassword] = useState(true)
    let logoBusiness = ""

    if (localStorage.getItem('logo') != '' && localStorage.getItem('logo') != null && localStorage.getItem('logo') != undefined) {
        logoBusiness = localStorage.getItem('logo')
    } else {
        logoBusiness = businessLogo
    }
    const toogglePasword = () => {
        setShowPassword((prev) => !prev);
    }

    const validWarehouse = () => {
        if (localStorage.getItem('warehouse') == null || localStorage.getItem('warehouse') == undefined || localStorage.getItem('warehouse') == '' || localStorage.getItem('warehouse') == null) {
            if (warehouses.length > 0) { setShowModalWarehouses(true) }
        }
    }


    const getUserDataByCode = async () => {
        let token = localStorage.getItem('x-access-machine-token');
        const response = await UsersFetchAPI.getUserByCode(codeUser, token);
        return response.data.user;
    };



    const isCashierAdmin = (user) => {
        const roles = Array.isArray(user?.role) ? user.role : [];
        return roles.some((r) => {
            const roleName = (r?.name || '').toLowerCase().trim();
            return roleName === 'cajero admin'
        });
    };


    const handleCodeStepContinue = async () => {
        if (!codeUser.trim()) {
            ErrorAlert('', 'Debes ingresar el código de usuario', 'warning');
            return;
        }

        LoadingAlert();

        try {
            const user = await getUserDataByCode();

            const requirePassword =
                authMode === 'code_pass' &&
                isCashierAdmin(user);

            if (requirePassword) {
                setPasswordUser('');
                setKeyboardMode('letters_upper');
                setStepLogin('password');
                Swal.close();
                return;
            }

            Swal.close();
            await getUserByCode();
        } catch (err) {
            Swal.close();
            setCodeUser('');
            ErrorAlert('', 'Código inválido', 'error');
            console.log(err);
        }
    };


    //consulta el usuario por codigo
    const getUserByCode = async () => {
        LoadingAlert()
        let token = localStorage.getItem('x-access-machine-token')
        let branhoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let userDataNow = JSON.parse(localStorage.getItem('user'))
        try {
            const response = await UsersFetchAPI.getUserByCode(codeUser, token)
            let user = response.data.user
            console.log(response.data);

            let dataBranhAndUser = user.branchoffices.find(branch => branch.branchoffice_id == branhoffice.id)
            console.log(dataBranhAndUser);

            if (dataBranhAndUser == undefined) {

                getUserByIdCard(user)

            } else {
                userDataNow.id = user.id
                userDataNow.lastName = user.lastName
                userDataNow.name = user.name
                userDataNow.user_code = user.user_code
                userDataNow.email = user.email
                userDataNow.idCard = user.idCard
                userDataNow.business_id = user.business_id
                userDataNow.modules = user.modules
                userDataNow.permissions = user.permissions
                userDataNow.role = user.role
                localStorage.setItem('user', JSON.stringify(userDataNow))

                Swal.fire({
                    title: "Bienvenido " + user.name,
                    icon: "success",
                    draggable: true
                });
                validWarehouse()
                setShowLoginByCode(false)
            }

            setCodeUser('');
            setPasswordUser('');
            setStepLogin('code');
        } catch (err) {
            setCodeUser('');
            setPasswordUser('');
            ErrorAlert('', 'Codigo invalida', 'error')

            console.log(err);
        }

    }


    //consulta el usuario por codigo y password
    const getUserByCodeAndPassword = async () => {
        LoadingAlert()
        let token = localStorage.getItem('x-access-machine-token')
        let branhoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let userDataNow = JSON.parse(localStorage.getItem('user'))
        try {
            const response = await UsersFetchAPI.getUserByCodeAndPassword(codeUser, passwordUser, token)
            let user = response.data.user
            console.log(response.data);

            let dataBranhAndUser = user.branchoffices.find(branch => branch.branchoffice_id == branhoffice.id)
            console.log(dataBranhAndUser);

            if (dataBranhAndUser == undefined) {

                getUserByIdCard(user)

            } else {
                userDataNow.id = user.id
                userDataNow.lastName = user.lastName
                userDataNow.name = user.name
                userDataNow.user_code = user.user_code
                userDataNow.email = user.email
                userDataNow.idCard = user.idCard
                userDataNow.business_id = user.business_id
                userDataNow.modules = user.modules
                userDataNow.permissions = user.permissions
                userDataNow.role = user.role
                localStorage.setItem('user', JSON.stringify(userDataNow))

                Swal.fire({
                    title: "Bienvenido " + user.name,
                    icon: "success",
                    draggable: true
                });
                validWarehouse()
                setShowLoginByCode(false)
            }

            setCodeUser('');
            setPasswordUser('');
            setStepLogin('code');

        } catch (err) {
            setPasswordUser('');
            ErrorAlert('', ' Contraseña inválidos', 'error')
            console.log(err);
        }

    }


    //valida que el usuario con idCard este en la lista de usuarios de la sucursal o negocio
    const getUserByIdCard = async (userSelect) => {
        let token = localStorage.getItem('x-access-machine-token')
        let branhoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let userDataNow = JSON.parse(localStorage.getItem('user'))
        let business = JSON.parse(localStorage.getItem("business"))

        try {
            const response = await UsersFetchAPI.getUserByIdCard(userSelect.idCard, token)
            let arrayUser = response.data.user;
            let business_id = 0;

            if (branhoffice.parthner_business) {
                business_id = branhoffice.parthner_business
            } else {
                business_id = business.id
            }

            let userByBusiness = arrayUser.find(user => user.business_id === business_id)
            if (userByBusiness !== undefined) {
                userDataNow.id = userByBusiness.id
                userDataNow.lastName = userByBusiness.lastName
                userDataNow.name = userByBusiness.name
                userDataNow.user_code = userByBusiness.user_code
                userDataNow.email = userByBusiness.email
                userDataNow.idCard = userByBusiness.idCard
                userDataNow.business_id = userByBusiness.business_id
                localStorage.setItem('user', JSON.stringify(userDataNow))

                Swal.fire({
                    title: "Bienvenido " + userSelect.name,
                    icon: "success",
                    draggable: true
                });

                validWarehouse()
                setShowLoginByCode(false)
            } else {
                console.log("user not found")
                ErrorAlert("", userSelect.name + " " + "no tiene permitido facturar aqui.", "warning");
            }

        } catch (err) {
            console.log(err);
            ErrorAlert("", "Error de consulta de usuario", "error");
        }
    }


    useEffect(() => {
        const machine = JSON.parse(localStorage.getItem('machine')) || {};
        setAuthMode(machine.user_code_auth_mode || 'code_only');
    }, []);


    useEffect(() => {
        if (showLoginByCode) {
            setCodeUser('');
            setPasswordUser('');
            setStepLogin('code');
            setKeyboardMode('letters_upper');
        }
    }, [showLoginByCode]);

    const appendToCode = (value) => {
        setCodeUser((prev) => prev + value);
    };

    const removeLastCodeChar = () => {
        setCodeUser((prev) => prev.slice(0, -1));
    };

    const appendToPassword = (value) => {
        setPasswordUser((prev) => prev + value);
    };

    const removeLastPasswordChar = () => {
        setPasswordUser((prev) => prev.slice(0, -1));
    };

    const alphaKeyboardRows = [
        ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
        ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
        ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
    ];

    const numericKeyboardRows = [
        ['1', '2', '3'],
        ['4', '5', '6'],
        ['7', '8', '9'],
        ['0']
    ];

    const alphaLowerKeyboardRows = [
        ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
        ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
        ['z', 'x', 'c', 'v', 'b', 'n', 'm']
    ];

    const symbolKeyboardRows = [
        ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')'],
        ['-', '_', '=', '+', '[', ']', '{', '}', ';', ':'],
        ['.', ',', '/', '?', '|', '\\', "'", '"']
    ];

    if (!showLoginByCode) return null;

    return createPortal(
        <div className="lgn-overlay" role="dialog" aria-modal="true" aria-label="Acceso SmartPay">
            <div className="lgn-dialog">

                {/* ---------------- HEADER ---------------- */}
                <header className="lgn-head">
                    <img src={logoBusiness} className="lgn-logo" alt="" loading="lazy" />

                    <div className="lgn-head-text">
                        <span className="lgn-head-label">Acceso SmartPay</span>
                        <span className="lgn-head-title">
                            {stepLogin === 'code' ? 'Ingresa tu código' : 'Ingresa tu contraseña'}
                        </span>
                    </div>

                    {parthners.length > 0 ? (
                        <div className="lgn-parthners">
                            <ModalParthners parthners={parthners} selectRestaurant={selectRestaurant} setResetData={setResetData} calculateInvoiceTotals={calculateInvoiceTotals} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} setShoppingCart={setShoppingCart} setShoppingCartCombos={setShoppingCartCombos} />
                        </div>
                    ) : null}
                </header>

                {/* ---------------- BODY ---------------- */}
                <div className="lgn-body">

                    {stepLogin === 'code' && (
                        <>
                            <input
                                type={showPassword ? 'password' : 'text'}
                                className="lgn-display"
                                id="code"
                                name="code"
                                placeholder="• • • •"
                                required
                                spellCheck="false"
                                autoComplete="off"
                                inputMode="none"
                                readOnly
                                value={codeUser}
                                onChange={(e) => setCodeUser(e.target.value)}
                            />

                            <div className="lgn-pad">
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                                    <button
                                        type="button"
                                        key={num}
                                        className="lgn-key"
                                        onClick={() => appendToCode(String(num))}
                                    >
                                        {num}
                                    </button>
                                ))}

                                <button
                                    type="button"
                                    className="lgn-key lgn-key--del"
                                    aria-label="Borrar"
                                    onClick={removeLastCodeChar}
                                >
                                    <i className="uil uil-backspace" />
                                </button>

                                <button
                                    type="button"
                                    className="lgn-key"
                                    onClick={() => appendToCode('0')}
                                >
                                    0
                                </button>

                                <button
                                    type="button"
                                    className="lgn-key lgn-key--go"
                                    aria-label="Continuar"
                                    onClick={() => { handleCodeStepContinue() }}
                                >
                                    <i className="uil uil-arrow-right" />
                                </button>
                            </div>
                        </>
                    )}

                    {stepLogin === 'password' && (
                        <>
                            <input
                                type={showPassword ? 'password' : 'text'}
                                className="lgn-display"
                                id="password_user"
                                name="password"
                                placeholder="• • • • • •"
                                readOnly={showVirtualKeyboard}
                                spellCheck="false"
                                autoComplete="off"
                                inputMode="none"
                                value={passwordUser}
                                onChange={(e) => setPasswordUser(e.target.value)}
                            />

                            <div className="lgn-keyboard">
                                <Keyboard txt={passwordUser} setTxt={setPasswordUser} showVirtualKeyboard={showVirtualKeyboard} setShowVirtualKeyboard={setShowVirtualKeyboard} />
                            </div>
                        </>
                    )}

                    <label className="lgn-toggle">
                        <input
                            type="checkbox"
                            value="remember-me"
                            id="flexCheckDefault"
                            onChange={toogglePasword}
                        />
                        <span>Mostrar contraseña</span>
                    </label>

                    <p className="lgn-hint">
                        <i className="uil uil-info-circle" />
                        {authMode === 'code_pass'
                            ? 'Ingresa con tu código de usuario. Si eres cajero administrador, también deberás ingresar tu contraseña.'
                            : 'Ingresa con tu código de usuario.'}
                    </p>

                </div>

                {/* ---------------- FOOTER ---------------- */}
                {stepLogin === 'password' && (
                    <div className="lgn-foot">
                        <button
                            type="button"
                            className="lgn-btn lgn-btn--ghost"
                            onClick={() => {
                                setPasswordUser('');
                                setKeyboardMode('letters_upper');
                                setStepLogin('code');
                            }}
                        >
                            Volver
                        </button>

                        <button
                            type="button"
                            className="lgn-btn lgn-btn--go"
                            onClick={() => {
                                if (!passwordUser.trim()) {
                                    ErrorAlert('', 'Debes ingresar la contraseña', 'warning');
                                    return;
                                }
                                getUserByCodeAndPassword();
                            }}
                        >
                            Ingresar
                        </button>
                    </div>
                )}

            </div>
        </div>,
        document.body
    )
}

export default ModalLoginUserByCode